import styled from "styled-components/macro";

export const StyledTDDecoy = styled.div`
  width: 458px;
  height: 100px;
  border-radius: 10px;
  background: var(--menu-color-fullscreen);

  ${({ side }) => side === "right" && "margin-left:-229px;"}
`;

export const StyledTDDecoyLeft = styled.div`
  width: 76px;
  border-right: 1.5px solid var(--divider);
  float: left;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  cursor: pointer;
  &:hover {
    background: rgba(158, 158, 158, 0.2);
  }
  &:active {
    background: rgba(158, 158, 158, 0.4);
  }
  svg {
    margin-top: 30px;
    transition: all 300ms;
  }
  ${({ broken }) => broken && "background: rgba(158, 158, 158, 0.4);"}
`;

export const StyledTDDecoyRight = styled.div`
  width: 76px;
  border-left: 1.5px solid var(--divider);
  float: right;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
  &:hover {
    background: rgba(158, 158, 158, 0.2);
  }
  &:active {
    background: rgba(158, 158, 158, 0.4);
  }

  svg {
    margin-top: 25px;
    transition: all 300ms;
  }
`;

export const StyledTDDecoyMiddle = styled.div`
  width: 280px;
  padding-left: 10px;
  padding-right: 10px;
  color: var(--grey-0);
  font-family: "Inter";
  text-align: ${({ length }) => (length > 120 ? "left" : "center")};

  ${({ length }) => length <= 9 && "font-size: 55px;"};
  ${({ length }) => length > 9 && length <= 11 && "font-size:50px;"};
  ${({ length }) => length > 11 && length <= 18 && "font-size: 32px;"};
  ${({ length }) => length > 18 && length <= 35 && "font-size: 28px;"};
  ${({ length }) => length > 35 && length <= 50 && "font-size: 24px;"};
  ${({ length }) => length > 50 && length <= 65 && "font-size: 20px;"};
  ${({ length }) => length > 65 && length <= 100 && "font-size: 18px;"};
  ${({ length }) => length > 90 && "text-align: justify;"};
  ${({ length }) => length > 100 && length <= 150 && "font-size: 16px;"};
  ${({ length }) => length > 150 && length <= 180 && "font-size: 14px;"};
  ${({ length }) => length > 180 && "font-size: 13px;"};

  display: flex;
  align-items: center;
  justify-content: center;
  height: inherit;
`;

export const StyledTDDecoyHalf = styled.div`
  box-sizing: border-box;
  width: 229px;
  overflow: hidden;
  position: absolute;
  transition: all 300ms;
  ${({ broken }) => (broken ? "" : "transition: transform 300ms;")}
  top: 0;
  ${({ side }) => side === "left" && "left: 0;"}
  ${({ side }) => side === "right" && "right: 0; margin-left:-229px;"}
  ${({ broken, side }) => broken && side === "right" && "transform: rotate(20deg) translate(40px);"}
  ${({ broken, side }) => broken && side === "left" && "transform: rotate(-20deg) translate(-40px);"}
  /* ${({ broken }) => (broken ? "filter: drop-shadow(0px 2px 4px #aaa);" : "")} */
  ${({ killed, side }) => killed && side === "left" && "transform: rotate(-20deg) translate(-60px);"}
      ${({ killed, side }) => killed && side === "right" && "transform: rotate(20deg) translate(60px);"}
`;

export const StyledTDDecoyContainer = styled.div`
  overflow: visible;
  position: relative;
  width: 458px;
  height: 0px;
  ${({ broken }) => (broken ? "transition: all 0s;" : "transition: all 300ms;")}
  margin-top: 0px;
  background: var(--menu-color-fullscreen);
  border-radius: 10px;

  ${({ top }) => top && `top: ${top}px;`}
  ${({ left }) => left && `left: ${left}px;`}
  ${({ born }) => (born ? "height: 100px; margin-top: 22px;" : "")}
  ${({ broken }) => (broken ? "" : "box-shadow: 0 2px 4px #aaa;")}

  &.killed {
    transition: all 300ms;
    height: 0;
    opacity: 0;
    margin-top: 0;
  }

  &.invisible {
    opacity: 0;
  }

  &.small {
    transition: all 300ms;
    height: 0;
    margin: 0;
    padding: 0;
  }

  ${StyledTDDecoyLeft} {
    ${({ broken }) => broken && "background: rgba(158, 158, 158, 0.4);"}
  }
`;

export const StyledGhost = styled.div`
  margin: auto;
  position: absolute;
  width: 33px;
  height: 101px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
  margin-top: 0;
  svg {
    linearGradient {
      stop {
        stop-color: var(--grey-0);
      }
    }
  }

  &.ascend {
    transition: all 300ms;
    opacity: 1;
    margin-top: -100px;
  }

  &.ascended {
    transition: all 300ms;
    opacity: 0;
    margin-top: -200px;
  }
`;
